import axios from "axios";
import { Toast } from "../../util/Toast";
import {
    GET_APPROVAL_REQUESTS,
    GET_APPROVAL_REQUESTS_SUCCESS,
    GET_APPROVAL_REQUESTS_FAIL,
    CANCEL_APPROVAL_REQUEST,
    CANCEL_APPROVAL_REQUEST_SUCCESS,
    CANCEL_APPROVAL_REQUEST_FAIL,
    DECIDE_APPROVAL_REQUEST,
    DECIDE_APPROVAL_REQUEST_SUCCESS,
    DECIDE_APPROVAL_REQUEST_FAIL,
    CLOSE_CANCEL_REQUEST_DIALOG,
    CLOSE_DECIDE_REQUEST_DIALOG,
    SET_LOADING,
} from "./types";

// Get approval requests
export const getApprovalRequests = (params = {}) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });

    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.actionType) queryParams.append('actionType', params.actionType);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);

    const queryString = queryParams.toString();
    const url = queryString ? `adminApprovalRequest?${queryString}` : 'adminApprovalRequest';

    console.log("Making request to:", url);
    console.log("Authorization header:", axios.defaults.headers.common["Authorization"]);

    return axios
        .get(url)
        .then((res) => {
            console.log("Approval Requests Data: ", res.data);
            if (res.data.status) {
                dispatch({
                    type: GET_APPROVAL_REQUESTS_SUCCESS,
                    payload: {
                        requests: res.data.data,
                        meta: res.data.meta,
                        status: params.status || 'all'
                    }
                });
                dispatch({ type: SET_LOADING, payload: false });
                return res.data;
            } else {
                dispatch({ type: GET_APPROVAL_REQUESTS_FAIL, payload: res.data.message });
                dispatch({ type: SET_LOADING, payload: false });
                Toast("error", res.data.message);
                return Promise.reject(res.data);
            }
        })
        .catch((error) => {
            console.log("Get approval requests error: ", error);
            console.log("Error response:", error.response);
            dispatch({ type: GET_APPROVAL_REQUESTS_FAIL, payload: error.message });
            dispatch({ type: SET_LOADING, payload: false });
            Toast("error", error.response?.data?.error || error.message);
            return Promise.reject(error);
        });
};

// Cancel approval request
export const cancelApprovalRequest = (requestId, reason = '') => (dispatch) => {
    return axios
        .post(`adminApprovalRequest/${requestId}/cancel`, { reason })
        .then((res) => {
            console.log("Cancel Request Response: ", res.data);
            if (res.data.status) {
                dispatch({ type: CANCEL_APPROVAL_REQUEST_SUCCESS, payload: res.data.data });
                dispatch({ type: CLOSE_CANCEL_REQUEST_DIALOG });
                Toast("success", res.data.message || "Request cancelled successfully!");
                return res.data;
            } else {
                dispatch({ type: CANCEL_APPROVAL_REQUEST_FAIL, payload: res.data.message });
                Toast("error", res.data.message);
                return Promise.reject(res.data);
            }
        })
        .catch((error) => {
            console.log("Cancel request error: ", error);
            dispatch({ type: CANCEL_APPROVAL_REQUEST_FAIL, payload: error.message });
            Toast("error", error.response?.data?.error || error.message);
            return Promise.reject(error);
        });
};

// Decide approval request (approve/reject)
export const decideApprovalRequest = (requestId, decision, reason = '') => (dispatch) => {
    return axios
        .post(`adminApprovalRequest/${requestId}/decide`, { decision, reason })
        .then((res) => {
            console.log("Decide Request Response: ", res.data);
            if (res.data.status) {
                dispatch({ type: DECIDE_APPROVAL_REQUEST_SUCCESS, payload: res.data.data });
                dispatch({ type: CLOSE_DECIDE_REQUEST_DIALOG });
                Toast("success", res.data.message || `Request ${decision.toLowerCase()}d successfully!`);
                return res.data;
            } else {
                dispatch({ type: DECIDE_APPROVAL_REQUEST_FAIL, payload: res.data.message });
                Toast("error", res.data.message);
                return Promise.reject(res.data);
            }
        })
        .catch((error) => {
            console.log("Decide request error: ", error);
            dispatch({ type: DECIDE_APPROVAL_REQUEST_FAIL, payload: error.message });
            Toast("error", error.response?.data?.error || error.message);
            return Promise.reject(error);
        });
};
